<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <form-group
          horizontal
          name="seo_title"
          :label="$t('attributes.seo_title')"
        >
          <b-input
            v-model="form.seo_title"
            name="seo_title"
            :placeholder="
              $t('message.please_input') + $t('attributes.seo_title')
            "
          ></b-input>
        </form-group>
        <form-group
          horizontal
          name="seo_description"
          :label="$t('attributes.seo_description')"
        >
          <b-input
            v-model="form.seo_description"
            name="seo_description"
            :placeholder="
              $t('message.please_input') + $t('attributes.seo_description')
            "
          ></b-input>
        </form-group>
        <form-group
          horizontal
          name="seo_keyword"
          :label="$t('attributes.seo_keyword')"
        >
          <b-input
            v-model="form.seo_keyword"
            name="seo_keyword"
            :placeholder="
              $t('message.please_input') + $t('attributes.seo_keyword')
            "
          ></b-input>
        </form-group>

        <b-field horizontal>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>
  </section>
</template>

<script>
import { AREA_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import { maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'AreaSeoForm',

  props: {
    area: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,
      code: this.area.code,
      form: this.extractFormValues(this.area)
    }
  },

  validations: {
    form: {
      seo_title: { maxLength: maxLength(150) },
      seo_description: { maxLength: maxLength(150) },
      seo_keywords: { maxLength: maxLength(150) }
    }
  },
  watch: {
    area(newArea) {
      this.code = newArea.code
      this.form = this.extractFormValues(newArea)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        seo_title: data.seo_title,
        seo_description: data.seo_description,
        seo_keyword: data.seo_keyword
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${AREA_API}/${this.code}/seo`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
